import { useMemo } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

interface eventsType {
  value: string;
  label: string;
  messageFormat: (props: never) => string;
}

interface EventNamesAutocompleteProps {
  autocompleteValue: string;
  setAutoCompleteValue: (value: string) => void;
  size?: 'small' | 'medium';
  disabled?: boolean;
  hasError?: boolean;
  newKey?: string;
  events: eventsType[];
  helperText?: string;
  variant?: 'standard' | 'outlined' | 'filled';
}

export default function EventNamesAutocomplete({
  autocompleteValue,
  setAutoCompleteValue,
  size,
  disabled,
  hasError,
  events,
  helperText,
  newKey,
  variant,
}: EventNamesAutocompleteProps) {
  const key = useMemo(
    () => newKey || new Date().getTime().toString(),
    [newKey]
  );

  const eventValue = useMemo(() => {
    return events.find((event) => event.value === autocompleteValue);
  }, [autocompleteValue, events]);

  return (
    <Autocomplete
      key={key}
      id="events-autocomplete"
      disabled={disabled}
      componentsProps={{
        paper: {
          sx: {
            minWidth: 400,
          },
        },
      }}
      getOptionLabel={(option) => option.label}
      options={events.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })}
      size={size}
      autoComplete
      autoHighlight
      value={eventValue || undefined}
      onChange={(_event, newValue) => {
        setAutoCompleteValue(newValue?.value || '');
      }}
      noOptionsText="No Events Found"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search for a event"
          fullWidth
          error={hasError}
          helperText={helperText}
          variant={variant || 'outlined'}
        />
      )}
    />
  );
}
